const dateFormatRegex = /^\d{4}-(0?[1-9]|1[012])-(0?[1-9]|[12][0-9]|3[01])$/;

/**
 * Parses date string from `DateInput` and `DateRangeInput` into a Date
 *
 * @param {string} str
 * @returns {Date}
 */
export const parseDatePickerInput = (str: string): Date =>
  new Date(dateFormatRegex.test(str) ? `${str}T00:00:00` : str);
